import { captureException } from "@sentry/nextjs";
import Script from "next/script";
import { useCookies } from "react-cookie";

export const trackEvent = ({
  action,
  params,
}: {
  action: string;
  params: any;
}) => {
  try {
    window.gtag("event", action, params);
  } catch (error) {
    captureException(error);
  }
};

export function GoogleTag() {
  const [cookies] = useCookies();

  if (!process.env.ARAGRO_ENV) return null;

  return (
    <>
      <Script
        id="google-tag-loader"
        src="https://www.googletagmanager.com/gtag/js?id=G-FDJGH3P426"
      />

      <Script id="google-tag-init">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-FDJGH3P426', {
            'campaign_id': '${cookies["utm_id"] || ""}',
            'campaign_name': '${cookies["utm_name"] || ""}',
            'campaign_source': '${cookies["utm_source"] || ""}',
            'campaign_medium': '${cookies["utm_medium"] || ""}',
            'campaign_campaign': '${cookies["utm_campaign"] || ""}',
            'campaign_term': '${cookies["utm_term"] || ""}',
            'campaign_content': '${cookies["utm_content"] || ""}',
          });
        `}
      </Script>
    </>
  );
}
